module.exports = __webpack_public_path__ + "img/icon_finance.d031129f.png";